// extracted by mini-css-extract-plugin
export default {"rate":"UserContractPage-styles-module--rate--fWoYk","grade":"UserContractPage-styles-module--grade--zTq5X"};